// extracted by mini-css-extract-plugin
module.exports = {"root":"react-burger-menu_root__2YSk-","guestRoot":"react-burger-menu_guestRoot__3mR7G"};